/**
 * The Folder contract - the organisation's file vault.
 *
 * MODULE NAME vs TABLE NAMES: the product calls this **Folder** (the menu
 * item, the route, the audit tab). The tables are `vault_files` and
 * `vault_shares`. Both names are load-bearing; neither is a typo.
 *
 * A file is PRIVATE until a share row exists. There is no "unshared" state
 * to store - the absence of a row is the state.
 */
/** Who a grant reaches. Any of the three is the file OWNER's to give;
 *  nobody but the owner (or a Super Admin) may grant on a file. */
export const VaultShareScope = {
    /** Everyone in the organisation. */
    ORG: 'ORG',
    /** One department, matched against the viewer's `departmentId`. */
    DEPARTMENT: 'DEPARTMENT',
    /** One named colleague. */
    USER: 'USER',
};
export const VAULT_SHARE_SCOPE_LABEL = {
    ORG: 'Everyone',
    DEPARTMENT: 'Department',
    USER: 'Person',
};
/** Per-file cap. The route's raw-body limit enforces it before buffering;
 *  the service re-checks the real length. */
export const VAULT_FILE_MAX_BYTES = 25 * 1024 * 1024;
/**
 * How close to its expiry a file is "expiring soon", for the UI warning.
 * The sweeper does not use this - it only ever compares against NOW().
 */
export const VAULT_EXPIRY_SOON_MS = 24 * 60 * 60 * 1000;
export const VAULT_FILE_NAME_MAX = 255;
export const VAULT_DESCRIPTION_MAX = 1000;
/**
 * What may be uploaded, by SNIFFED type.
 *
 * SVG is absent on purpose: it is an image format that can carry <script>,
 * and served back from your own domain that is stored XSS. Everything here
 * is identified by magic bytes; the browser's Content-Type is ignored.
 */
export const VAULT_ALLOWED_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    // The OOXML family and ODF are ZIP containers - they sniff as PK\\x03\\x04
    // and are told apart by the declared extension, which is why the
    // extension still matters even though the header is what is trusted.
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/zip',
    'text/plain',
    'text/csv',
];
//# sourceMappingURL=vault.js.map